import React from 'react';
import { Box } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';

import buttonHome from '../../../assets/icons/buttonHome.svg';
import buttonBack from '../../../assets/icons/buttonBack.svg';

export const NavigationButtonsStyled = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    // Takes the user to the previous page
    navigate(-1);
  };

  return (
    <Box sx={twoBtnBoxStyle}>
      {/* Back button: go back one page */}
      <Box component="button" onClick={handleBack} sx={buttonStyle}>
        <img src={buttonBack} alt="back" />
      </Box>

      {/* Home */}
      <Link to={'/'} style={linkStyle}>
        <img src={buttonHome} alt="home" />
      </Link>

      {/* Next (or hidden next) */}
      {<></>}
    </Box>
  );
};

// Optional styling for the <button> or <Link>
const buttonStyle = {
  // Remove default button styling if you like:
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  padding: 0,
  // Center the icon
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};

// Styling for the <Box> to accomodate two buttons (previous, home)
const twoBtnBoxStyle = {
  margin: 'auto 0.625rem 0.625rem 0.625rem',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-around',
  width: '150px',
  height: '60px',
  backgroundColor: '#fff',
  borderRadius: '100px',
  marginRight: '75px'
};

const linkStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};
